import { httpClient } from "@/app/client/httpClient";

class OperationsService {
  fetchOperationsList() {
    return httpClient.orders.operations.$get();
  }
}

export const operationsService = new OperationsService();
